import { combineEpics } from 'redux-observable';
import { closeCoreSymbolBeforeRemoveEpic } from './_epics/closeCoreSymbolBeforeRemove.epic';
import { handleCoreSymbolNotFoundEpic } from './_epics/handleCoreSymbolNotFound.epic';
import { reloadSymbolListEpic } from './_epics/reloadSymbolList.epic';
import { toggleViewCoreSymbolSidebarEpic } from './_epics/toggleViewCoreSymbolSidebar.epic';
import { closeBulkEditSidebarOnDoneEpic } from './_epics/closeBulkEditSidebarOnDone.epic';

export const controllerCoreSymbolEpic = combineEpics(
  closeCoreSymbolBeforeRemoveEpic,
  handleCoreSymbolNotFoundEpic,
  reloadSymbolListEpic,
  toggleViewCoreSymbolSidebarEpic,
  closeBulkEditSidebarOnDoneEpic,
);
